import { Box, IconButton, TextField } from "@mui/material";
import { SxProps } from "@mui/material/styles";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { Dayjs } from "dayjs";
import { colorBorder, colorTextSecondary, radiusInput } from "src/design/tokens";

interface TableScheduleDateNavProps {
  date: Dayjs;
  onChange: (date: Dayjs) => void;
  sx?: SxProps;
}

export const TableScheduleDateNav = ({
  date,
  onChange,
  sx,
}: TableScheduleDateNavProps) => (
  <LocalizationProvider dateAdapter={AdapterDayjs}>
    <Box sx={{ display: "flex", alignItems: "center", gap: 0.5, ...sx }}>
      <IconButton
        size="small"
        aria-label="previous-day"
        onClick={() => onChange(date.subtract(1, "day"))}
        sx={{ color: colorTextSecondary }}
      >
        <ChevronLeftIcon fontSize="small" />
      </IconButton>

      <DatePicker
        value={date}
        onChange={(value) => value && onChange(value)}
        renderInput={(params) => (
          <TextField
            {...params}
            size="small"
            sx={{
              width: { xs: 132, sm: 170 },
              "& .MuiOutlinedInput-input": { py: { xs: 0.75, sm: 1 } },
              "& .MuiOutlinedInput-root": { borderRadius: radiusInput },
              "& fieldset": { borderColor: colorBorder },
            }}
          />
        )}
      />

      <IconButton
        size="small"
        aria-label="next-day"
        onClick={() => onChange(date.add(1, "day"))}
        sx={{ color: colorTextSecondary }}
      >
        <ChevronRightIcon fontSize="small" />
      </IconButton>
    </Box>
  </LocalizationProvider>
);
